import { render, staticRenderFns } from "./employeeMain.vue?vue&type=template&id=deddaad6"
import script from "./employeeMain.vue?vue&type=script&lang=js"
export * from "./employeeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports